import React from 'react';
import { Title } from '../../styles';
import LocationFormFields from 'modules/Experience/components/LocationFormFields';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LocationForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.edit_location.${key}`);
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <React.Fragment>
            <Title title={translate('title')} description={translate('description')} />

            <LocationFormFields order={isMobile ? 0 : 1} />
        </React.Fragment>
    );
};

export default LocationForm;
